'use strict';

require('./polyfills');

function getFromLocalStorage(key) {
    var result;
    try {
        result = JSON.parse(localStorage.getItem(key));
    } catch(e) {
        return {
            error: e,
            result: null
        };
    }

    return {
        error: null,
        result: result
    };
}

function saveToLocalStorage(key, obj) {
    try {
        var serializedObj = JSON.stringify(obj);
        localStorage.setItem(key, serializedObj);
    } catch(e) {}
}

function removeFromLocalStorage(key) {
    try {
        localStorage.removeItem(key);
    } catch(e) {}
}

function getDataFromBE(url, onSuccess, onError) {
    var ajaxRequest = new XMLHttpRequest();
    ajaxRequest.addEventListener('load', function() {
        if (ajaxRequest.status < 200 || ajaxRequest.status >= 300) {
            onError();
            return;
        }

        var rawData = ajaxRequest.response,
            data;

        try {
            data = JSON.parse(rawData);
        } catch(e) {}

        if (!data) {
            onError();
            return;
        }

        onSuccess(data, ajaxRequest);
    });

    ajaxRequest.addEventListener('error', onError);

    ajaxRequest.open('GET', url);
    ajaxRequest.send();
}

var isObject = require('./utils').isObject,
    buildURL = require('./utils').buildURL,

    Captcha = require('./captcha'),
    POW = require('./pow'),

    ChallengeType = {
        CAPTCHA: 'captcha',
        POW: 'pow'
    },
    Errors = {
        LOCALSTORAGE_NOT_SUPPORTED: 'localstorage_not_supported',
        POW_NOT_SUPPORTED: 'pow_not_supported',
        POW_NOT_SOLVED: 'pow_not_solved',
        REQUEST_TIMEOUT: 'request_timeout'
    },

    defaultOptions = {
        feature: null,
        url: null,

        resolved: function() {},
        error: function() {},

        preferredChallengeType: ChallengeType.POW,
        fallbackChallengeType: ChallengeType.CAPTCHA,
        challengeLifetime: 10 * 60,  // seconds
        challengeBanTimeout: 1,  // seconds

        powEvalPath: null,
        powSHA3Path: null,

        loggingEnabled: false,
        debugEnabled: false,
        syncStorageEnabled: false,
        errorRequestsLimit: 0
    },

    // localStorage keys
    challengeKey = 'challenge',
    resultsKey = 'results',
    expiresAtKey = 'expiresAt';

function iedetect() {
    var ua = window.navigator.userAgent,
        msie = ua.indexOf('MSIE '),
        trident = ua.indexOf('Trident/'),
        edge = ua.indexOf('Edge/'),
        rv = ua.indexOf('rv:');

    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    if (trident > 0) {
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    if (edge > 0) {
       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    return false;
}

function Riddler(options) {
    if (!isObject(options)) {
        options = {};
    }

    this.options = Object.assign({}, defaultOptions, options);

    this.options.syncStorageEnabled = !iedetect() && options.syncStorageEnabled;

    if (!this.options.loggingEnabled) {
        this.log = function() {};
    }

    this.challengeType = this.options.preferredChallengeType;
    if (!Riddler.proofOfWorkSupported()) {
        this.log(Errors.POW_NOT_SUPPORTED, {
            localStorageSupported: Riddler.localStorageSupported(),
            webWorkersSupported: Riddler.webWorkersSupported()
        });
        this.challengeType = this.options.fallbackChallengeType;
    }
    if (this.options.syncStorageEnabled) {
        window.addEventListener('storage', this.onStorageKeyUpdate.bind(this));
    }
}

Riddler.ChallengeType = ChallengeType;
Riddler.Errors = Errors;

Riddler.localStorageSupported = function() {
    var localStorageTestKey = 'riddler_localstorage_support_test';

    try {
        localStorage.setItem(localStorageTestKey, true);
        localStorage.removeItem(localStorageTestKey);

        return true;
    } catch (e) {
        return false;
    }
};

Riddler.webWorkersSupported = function() {
    return POW.isSupported();
};

Riddler.proofOfWorkSupported = function() {
    return Riddler.localStorageSupported() && Riddler.webWorkersSupported();
};

Riddler.prototype = {
    onStorageKeyUpdate: function(event) {
        var isResultKey, newValueIsDefined;
        var key = event.key;

        if (!key) {
            return;
        }
        isResultKey = event.key.indexOf(this.getLocalStorageKey(resultsKey)) > -1;
        newValueIsDefined = event.newValue !== undefined;

        if (isResultKey && newValueIsDefined) {
            var resultsLS = getFromLocalStorage(this.getLocalStorageKey(resultsKey));
            if (!resultsLS.error && resultsLS.result) {
                this.resolved(resultsLS.result);
            }
        }
    },
    solve: function() {
        if (Riddler.localStorageSupported()) {
            this.retrieveChallengeFromLocalStorage();
        } else {
            this.retrieveChallengeFromBackend();
        }
    },
    update: function(challengeType) {
        if (challengeType) {
            this.challengeType = challengeType;
        }
        this.retrieveChallengeFromBackend();
    },
    clear: function() {
        removeFromLocalStorage(this.getLocalStorageKey(challengeKey));
        removeFromLocalStorage(this.getLocalStorageKey(resultsKey));
        removeFromLocalStorage(this.getLocalStorageKey(expiresAtKey));
    },
    log: function(message, tags) {
        tags = tags || {};
        Raven.captureMessage(message, {tags: tags});
    },
    retrieveChallengeFromLocalStorage: function() {
        var expiresAtLS = getFromLocalStorage(this.getLocalStorageKey(expiresAtKey));
        if (!expiresAtLS.result || this.checkIsExpired(expiresAtLS.result)) {
            this.retrieveChallengeFromBackend();
            return;
        }

        var resultsLS = getFromLocalStorage(this.getLocalStorageKey(resultsKey));
        if (isObject(resultsLS.result)) {
            this.resolved(resultsLS.result);
            return;
        }

        var challengeLS = getFromLocalStorage(this.getLocalStorageKey(challengeKey));
        if (!isObject(challengeLS.result)) {
            this.retrieveChallengeFromBackend();
            return;
        }

        this.solveChallenge(challengeLS.result);
    },
    retrieveChallengeFromBackend: function(count) {
        var queryParams;
        if (count === undefined) {
            count = 0;
        }
        this.clear();
        queryParams = {
            type: this.challengeType
        };

        if (this.options.debugEnabled) {
            queryParams.reduce_riddler_complexity = this.options.debugEnabled; // jshint ignore:line
        }

        var url = buildURL(this.options.url, queryParams);

        var successHandler = function(data, xhr) {
            var expiresAt = Date.now() / 1000 + this.options.challengeLifetime;

            var key;
            if (this.options.challengeKeyHeader) {
                key = xhr.getResponseHeader(this.options.challengeKeyHeader);
            }
            saveToLocalStorage(this.getLocalStorageKey(expiresAtKey), expiresAt);
            saveToLocalStorage(this.getLocalStorageKey(challengeKey), data);
            this.solveChallenge(data, key);
        }.bind(this);

        var errorHandler = this.options.errorRequestsLimit > 0
            ? function() { // jshint ignore:line
                if (count >= this.options.errorRequestsLimit) {
                    this.options.error(Errors.REQUEST_TIMEOUT);
                    return;
                }
                setTimeout(
                    this.retrieveChallengeFromBackend.bind(this, count + 1),
                    this.options.challengeBanTimeout * 1000 + (500 * count)
                );
            }.bind(this)
            : function() {
                setTimeout(
                    this.retrieveChallengeFromBackend.bind(this),
                    this.options.challengeBanTimeout * 1000
                );
            }.bind(this);

        getDataFromBE(url, successHandler, errorHandler);
    },
    solveChallenge: function(challenge, key) {
        var defaultOptions = {
                resolved: this.resolved.bind(this)
            },
            options;

        this.challengeType = Object.values(challenge)[0].type;

        if (this.challengeType === ChallengeType.CAPTCHA) {
            options = Object.assign({}, defaultOptions, { challengeKey: key });
            new Captcha(options).solve(challenge);
        } else if (this.challengeType === ChallengeType.POW) {
            options = Object.assign({}, defaultOptions, {
                evalPath: this.options.powEvalPath,
                sha3Path: this.options.powSHA3Path,
                challengeKey: key
            });
            new POW(options).solve(challenge);
        }
    },

    resolved: function(results) {
        if (results.type === ChallengeType.POW && !results.results) {
            this.log(Errors.POW_NOT_SOLVED);
        }
        saveToLocalStorage(this.getLocalStorageKey(resultsKey), results);
        this.options.resolved(results);
    },

    getResults: function(cb) {
        if (!Riddler.localStorageSupported()) {
            cb(Errors.LOCALSTORAGE_NOT_SUPPORTED);
            return;
        }

        var resultsLS = getFromLocalStorage(this.getLocalStorageKey(resultsKey));

        if (resultsLS.error) {
            cb(Errors.LOCALSTORAGE_NOT_SUPPORTED);
            return;
        }

        cb(null, resultsLS.result);
    },
    checkIsExpired: function(expiresAt) {
        var now = Date.now() / 1000;

        return expiresAt < now;
    },
    getLocalStorageKey: function(key) {
        return 'wg-riddler-localStorage/' + this.options.feature + ':' + key;
    }
};

module.exports = Riddler;
